// src/store/index.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isEnglish: false,
  },
  mutations: {
    setLanguage(state, isEnglish) {
      state.isEnglish = isEnglish;
    },
  },
  actions: {
    changeLanguage({ commit }, isEnglish) {
        commit('setLanguage', isEnglish); // 提交语言状态的 mutation
    },
  },
});
